// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__38eFt","amount":"Amount_amount__3Tdt9","tip":"Amount_tip__2MPwW","tipHeader":"Amount_tipHeader__1NQag","tipsWrap":"Amount_tipsWrap__19h6C"};